<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-8 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.name }}</h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-4 text-right">
          <div class="box-buttons">
            <base-button type="primary" class="min-button" @click="saveEvent()">
              <i class="flaticon-floppy-disk"></i> Save
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <EventForm
        :value="event"
        :v="$v.event"
        :customer-options="customerOptions"
      />
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { EventsAPI } from "@/core/api";
import { goBack, setSigOut } from "@/helpers/commons.helpers";
import EventForm from "../components/EventForm.vue";
import {
  buildEmptyEventForm,
  buildCreateEventPayload
} from "../services/event-form.service";
import { EVENT_FORM_VALIDATIONS } from "../services/event-form.validations";
import { getEventErrorMessage } from "../services/event-error.service";

const ERROR_MESSAGE = "The Operation couldn't be completed. Please try again";

export default {
  name: "NewEvent",
  data() {
    return {
      event: buildEmptyEventForm()
    };
  },
  computed: {
    ...mapGetters(["sesion", "customerOptions"])
  },
  mounted() {
    this.setItemsBread([
      { text: "Dashboard", to: "/dashboard" },
      { text: "Tools", to: "/tools" },
      { text: "Events", to: "/tools/events" },
      { text: "New Event", active: true }
    ]);
  },
  created() {
    if (!this.customerOptions.length) this.getCustomerOptions();
  },
  methods: {
    async saveEvent() {
      if (this.$v.event.$invalid) {
        this.$v.event.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
        return;
      }
      await this.createEvent(buildCreateEventPayload(this.event));
    },
    async createEvent(payload) {
      try {
        this.setLoad(true);
        const { data } = await EventsAPI.createEvent(
          payload,
          this.sesion.token
        );
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Event has been Saved",
          icon: "flaticon-check-mark"
        });
        this.$router.push(`/tools/events/${data._id}`);
      } catch (error) {
        this.handleError(error, ERROR_MESSAGE);
      } finally {
        this.setLoad(false);
      }
    },
    handleError(error, message) {
      if (error.response && error.response.data.code === 401) {
        if (setSigOut(error)) this.setSigOut(true);
        return;
      }
      this.$notify({
        type: "danger",
        title: "Error!",
        message: getEventErrorMessage(error, message),
        icon: "flaticon-remove"
      });
    },
    goToPreviousPage() {
      goBack(this);
    },
    ...mapMutations(["setSigOut", "setLoad", "setItemsBread"]),
    ...mapActions(["getCustomerOptions"])
  },
  validations: {
    event: EVENT_FORM_VALIDATIONS
  },
  components: {
    EventForm
  }
};
</script>
